import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import ThunkMiddleware from "redux-thunk";
import reducer  from '../reducers/reducer';

const loadState = () => {
  try {
    const ser = sessionStorage.getItem('campUserInfo');
    if (ser === null) {
      return undefined;
    }
    return JSON.parse(ser);
  } catch (err) {
    return undefined;
  }
};

function storeConfiguration() {
    const store = configureStore({
      reducer,
      middleware:[ThunkMiddleware],
      devTools: process.env.NODE_ENV !== 'production',
      preloadedState: loadState(),
    });

  return {
    store,
    Provider
  };
}

export default storeConfiguration;